export default __webpack_public_path__ + "static/media/Info-icon-yellow.523d2563.svg";